export enum PlatformEnum {
  Liv = 1,
  MyWorld = 2
}
